import usePlaceSelection from './hooks/usePlaceSelection'
import usePlaceMapParams from './hooks/usePlaceMapParams'
import React, { useEffect, useState } from 'react'
import PlaceMapData from './PlaceMapData'
import Summary from './Summary'
import Header from './Header'
import List from './List'
import Map from './Map'
import './style.scss'

const PlaceMapContent: React.FC<{ isMap: boolean, showMap: React.Dispatch<React.SetStateAction<boolean>> }> = ({ isMap, showMap }) => {
  const [selectedGroupKey, selectGroup] = useState<string>()
  const { isGroupMode, isVisible, selectedKey, selection } = usePlaceSelection(isMap, selectedGroupKey)
  const { id } = usePlaceMapParams()

  // Zmiana magazynu w URL (np. przez filtry) resetuje ręczny wybór grupy
  useEffect(() => {
    selectGroup(undefined)
  }, [id])

  const header = <Header
    isMap={isMap}
    showMap={showMap}
  />

  return (
    <div className='placeMap'>
      <div className='placeMap__container'>
        {isMap
          ? <Map header={header} />
          : <List
            header={header}
            isGroupMode={isGroupMode}
            selectedKey={selectedKey}
            selectGroup={selectGroup}
          />}
        <div className={`placeMap__summary__wrapper${isVisible ? '' : ' --hidden'}`}>
          <Summary selection={selection} />
        </div>
      </div>
    </div>
  )
}

const PlaceMap: React.FC = () => {
  const [isMap, showMap] = useState(true)

  return (
    <PlaceMapData showMap={showMap}>
      <PlaceMapContent
        isMap={isMap}
        showMap={showMap}
      />
    </PlaceMapData>
  )
}

export default PlaceMap
